import { Mark } from '@/components/brand/Brand'
import { GlassPanel } from '@/components/sections/GlassPanel'
import { BookCallButton } from '@/components/ui/Button'
import { siteConfig } from '@/config/site'
import { cx } from '@/lib/cx'

type InviteSectionProps = {
  id: string
  titleId: string
  eyebrow: string
  title: string
  lead: string
  className?: string
}

/** The invitation that closes a page: the hero's glass returns, with a card to book a call. */
export const InviteSection = ({ id, titleId, eyebrow, title, lead, className }: InviteSectionProps) => (
  <GlassPanel className={cx('x-invite', className)} shade="invite" id={id} labelledBy={titleId}>
    <div className="x-wrap x-invite-grid">
      <div className="x-invite-copy">
        <p className="x-eyebrow x-eyebrow--ink">{eyebrow}</p>
        <h2 id={titleId} className="x-invite-title">
          {title}
        </h2>
        <p className="x-invite-lead">{lead}</p>
      </div>
      <div className="x-invite-card">
        <div className="x-invite-head">
          <span className="x-invite-mark" aria-hidden="true">
            <Mark />
          </span>
          <p className="x-invite-name">First conversation</p>
        </div>
        <BookCallButton />
        <p className="mono x-invite-or">Or email</p>
        <a className="x-invite-mail" href={`mailto:${siteConfig.email}`}>
          {siteConfig.email}
        </a>
      </div>
    </div>
  </GlassPanel>
)
